
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21.043","height":"21"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M21.033 13.229a3.08 3.08 0 01-.412 1.1 2.332 2.332 0 01-1.841 1.084c-.786.038-1.573.01-2.369.01V13.8h2.139a.822.822 0 00.844-.844V6.13c0-.038-.01-.077-.01-.125H1.65v6.859a.838.838 0 00.94.931h2.081v1.64h-.965c-.508-.01-1.026.019-1.535-.029A2.437 2.437 0 01.013 12.96c-.01-2.235 0-4.48 0-6.715 0-1.209.019-2.427-.01-3.636A2.5 2.5 0 012.094.028a.081.081 0 00.048-.029h16.764a.707.707 0 00.134.038 2.448 2.448 0 011.87 1.65c.058.153.086.326.134.489q-.016 5.524-.011 11.053zm-1.65-9.709v-.911a.848.848 0 00-.969-.969H2.475a.774.774 0 00-.815.691c-.038.393-.01.787-.01 1.19z"}}),_c('path',{staticClass:"a",attrs:{"d":"M11.375 17.873c.729-.729 1.448-1.468 2.168-2.187.393.393.777.777 1.151 1.142l-4.172 4.173c-1.391-1.391-2.791-2.782-4.182-4.173.364-.365.748-.739 1.132-1.122.71.71 1.429 1.439 2.158 2.159.019-.01.029-.019.048-.029v-6.6h1.64v6.619a.1.1 0 01.057.018zM13.629 7.243v1.612H2.801V7.243z"}})])
          )
        }
      }
    